export const CLOCK_TIME_INPUT_NAME = {
    START_TIME: 'START_TIME',
    END_TIME: 'END_TIME',
    CLOCK_IN: 'CLOCK_IN',
    STATIONS: 'STATIONS',
    STATION_START_TIME: 'STATION_START_TIME',
    STATION_END_TIME: 'STATION_END_TIME',
    DELETE_STATION: 'DELETE_STATION',
}

export const ACTUAL_CLOCK_ACTION_VIOLATION_SEVERITY = {
    WARNING: 'warning',
    ERROR: 'error',
};

export const ACTUAL_CLOCK_ACTION_VIOLATION_TYPE = {
    RIGHT_TO_REST: 'right_to_rest',
    REPORTING_TIME: 'call_in'
};

export const ACTUAL_CLOCK_ACTION_VIOLATION_TYPE_LABEL = {
    [ACTUAL_CLOCK_ACTION_VIOLATION_TYPE.RIGHT_TO_REST]: `RTR ${$filter('translate')('premium')}`,
    [ACTUAL_CLOCK_ACTION_VIOLATION_TYPE.REPORTING_TIME]: $filter('translate')('Reporting time'),
};